<template>
  <label :for="getId" :class="$style.container">
    <span :class="[$style.label, $style[labelPosition]]">
      {{ label }}
    </span>
    <div :class="$style.radioButton">
      <input
        :id="getId"
        type="radio"
        :class="$style.input"
        :checked="isChecked"
        :value="value"
        @change="handleChange"
      />
      <span :class="$style.bubble"></span>
    </div>
  </label>
</template>

<script>
import { inArray } from 'lib/component/validators';
import { generateRandomString } from 'lib/utils/string';

export default {
  name: 'RadioButton',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelPosition: {
      type: String,
      validator: inArray(['left', 'right']),
      default: 'right',
    },
  },
  data() {
    return {
      getId: generateRandomString(),
    };
  },
  computed: {
    isChecked() {
      // eslint-disable-next-line eqeqeq
      return this.modelValue == this.value;
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.value);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    align-items: center

  .label
    +radio-label
    cursor: pointer

    &.left
      margin-right: 10px

    &.right
      margin-left: 10px
      order: 1

  .radioButton
    position: relative

  .input
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    opacity: 0
    appearance: none
    cursor: pointer

    &:checked
      & + .bubble
        background: rgba(124, 179, 66, 1)

      & + .bubble::after
        width: 14px
        height: 14px
        background: rgba(255, 255, 255, 1)

  .bubble
    display: flex
    justify-content: center
    align-items: center
    width: 26px
    height: 26px
    border-radius: 50%
    background: rgba(33, 33, 33, 0.15)

    &::after
      content: ''
      width: 10px
      height: 10px
      border-radius: 50%
      background: rgba(60, 64, 67, 0.5)
      transition: all 0.2s linear
</style>
